import React, { forwardRef } from "react";
import cx from "classnames";
import styled from 'styled-components';
import { useJson } from "../Hooks/useJson";
import IBuildrProps from '../../utilities/IBuildrProps';
import mardownToText from "../../utilities/markdown-to-text";

interface IAccordionFaq extends IBuildrProps {
    enableSchema: boolean;
    children: any;
}

export default styled(forwardRef((props: IAccordionFaq, ref: any) => {
    const { cmsId, editorClassObj, className, children = [], enableSchema } = props;
    const windowObj = typeof window !== 'undefined' ? window : {} as any;
    const currentHash = windowObj.location?.hash;
    const answers = Array.isArray(children) ? children : [children];

    const schema = JSON.stringify({
        "@context":"https://schema.org",
        "@type":"FAQPage",
        "mainEntity" : answers.map(item => {
            return {
                "@type":"Question",
                "name": item.props.question,
                "acceptedAnswer":{
                    "@type":"Answer",
                    "text": mardownToText(item.props.answer),
                }
            }
        })
    })

    useJson(schema, Boolean(enableSchema));

    return (
        <div ref={ref} data-id={cmsId} className={cx("accordion py-3", className, editorClassObj)}> 
            {React.Children.map(children,(item, index) => {
                return React.cloneElement(item, {
                    index,
                    hash: currentHash || ''
                });
            })}
        </div>
    );
}))`

`;
